import {ConnectedComponent} from '@lib/ConnectedComponent';
import {appSelectors} from '@lib/store/appState';
import {MediaQuery} from '@services/MediaQuery';

export class Header extends ConnectedComponent {
  private mq = MediaQuery.create();

  didMount() {
    this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
      if (status === 'startHideAnimation') {
        this.element?.classList.add('viewed');
      }
    });
  }
}
